import { render } from "./ServiceCard.vue?vue&type=template&id=28029910&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"

import "./ServiceCard.vue?vue&type=style&index=0&id=28029910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28029910"]])

export default __exports__